import { AsyncPipe } from '@angular/common';
import { Component, EventEmitter, Output, inject } from '@angular/core';
import { TranslocoPipe } from '@jsverse/transloco';
import { SavingsPlanFacade } from '@zero/saving-plans/domain';
import { CustomerStateFacade } from '@zero/shared/util-global-state';

@Component({
  selector: 'saving-plans-crypto-hint',
  imports: [TranslocoPipe, AsyncPipe],
  templateUrl: './savings-plan-crypto-hint.component.html',
})
export class SavingsPlanCryptoHintComponent {
  public readonly facade = inject(SavingsPlanFacade);
  public readonly customerStateFacade = inject(CustomerStateFacade);

  @Output() public noWalletWarningClick = new EventEmitter();
}
